import React, { useContext } from "react";
import styled from "styled-components";
import { FilterSallesContext } from "../../context/filterSalles";
import { RequestsContext } from "../../context/requests";

const CardWrapper = styled.div`
    margin-top: 1.9rem;
    margin-bottom: 0.5rem;
    margin-left: 0.3rem;
    display: flex;
`
const Card = styled.div`
    cursor: pointer;
    display:flex;
    align-items: center;
    margin-right: 2rem;
    height:20px;
    p{
        font-size: 0.9rem;
        font-family: "Poppins";
        font-weight: 500;
        margin-left:0.3rem;
    }
`
const Circle = styled.div`
    position: relative;
    top: -7px;
    width:10px;
    height:10px;
    border-radius:100px;

`

const FilterSalles = ({ name, data, status }) => {
    const { option, setOption } = useContext(FilterSallesContext)
    const { 
        getAll,
        getLast30Days,
        getByUniqDate,
        getRangeDate,
        setSelectItems,
        getAllRequests,
        typeFilter,
        requests
    } = useContext(RequestsContext)
    


    const filter = (option) => {
        
        if(typeFilter == "últimos 30 dias"){
            getLast30Days(option)
            
        }
        if(typeFilter == "por data"){
            getByUniqDate(option)
        }
        if(typeFilter == "por intervalo"){
            getRangeDate(option)
        }

        if(!typeFilter){
            getAll(option)
        }

    }

    return (

        <CardWrapper>
            {data?.map(item => {
                return (
                    <Card onClick={() => { setOption(item.id); filter(item.id);setSelectItems([]) }} style={{borderBottom: option == item.id ? `2px solid ${item.background}` : "" }}>
                        
                        {item.id == option ? <Circle style={{ backgroundColor: item.background }} />:<></> }
                        <p>
                            {item.name}
                            &nbsp;
                            {option == item.id ? requests.length : <></>}
                            
                        </p>
                    </Card>
                )
            })}

        </CardWrapper>

    )
}

export default FilterSalles